module.exports = cast.framework.system;